import { render, staticRenderFns } from "./landing-caborca.vue?vue&type=template&id=4d3fd673&scoped=true&"
import script from "./landing-caborca.vue?vue&type=script&lang=js&"
export * from "./landing-caborca.vue?vue&type=script&lang=js&"
import style0 from "./landing-caborca.vue?vue&type=style&index=0&id=4d3fd673&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3fd673",
  null
  
)

export default component.exports